<template>
    <div class="w-100">
        <multiselect v-model="model"
             class="w-100"
             label="name"
             track-by="value"
             :placeholder="placeHolder"
             :options="options"
             :noResult="'not found'"
             :noOptions="'not found'"
             :show-labels="false"
             :multiple="isMultiPle"
             :disabled="disabled"
        >
            <template v-if="$scopedSlots.tag" slot="tag" slot-scope="props">
                <slot name="tag" v-bind="props"></slot>
            </template>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import '../../assets/scss/vueselect.scss'
    export default {

        name : 'multiSelect',
        components : {Multiselect},
        props : {
            placeHolder: {type: String, default: 'Search...'},
            options: {
                type: Array,
                required: true
            },
            value: {
                required: true
            },
            isMultiPle: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean
            }
        },
        computed: {
            model : {
                get(){
                    return this.value
                },
                set(value){
                    this.$emit('input',value)
                }
            }
        },
        methods: {

        }

    }
</script>
<style>
    /*.multiselectComponent {*/
    /*    text-align: left !important;*/
    /*}*/
    /*.multiselect__current,*/
    /*.multiselect__select {*/
    /*    line-height: unset !important;*/
    /*}*/
    /*.multipleCombo > .multiselect__tags{min-height: 20px}*/
    /*.singleCombo > .multiselect__tags{height: 20px}*/


</style>
